import React, { useEffect, useState } from "react";
import styles from "../../BorrowerDetails.module.css";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { url } from "../../../../../App";
import axios from "axios";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import "react-toastify/dist/ReactToastify.css";
import Loan from "./Components/Loan/Loan";
import CoapplicantDetails from "./Components/Coapplicant/CoapplicantDetails";
import CollateralDetails from "./Components/Collateral/CollateralDetails";
import Analysis from "./Components/Analysis/Analysis";
import CAM from "./Components/CAM/Cam";
import { useBorrowerContext } from "../../store/borrower-details";
import { useParams } from "react-router";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const SectionTwo = ({ openLoader, closeLoader, permissions }) => {
  const [value, setValue] = useState(0);
  const { fetchData } = useBorrowerContext();
  const [isCoapplicant, setIsCoapplicant] = useState(false);
  const [isCollateral, setIsCollateral] = useState(false);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const { loanid } = useParams();
  console.log(loanid);

  useEffect(() => {
    const fetchLoanAndProduct = async () => {
      try {
        const loanRes = await axios.post(url + "/loan/getsingle", {
          token: Cookies.get("Token"),
          email: Cookies.get("Email"),
          loan_id: loanid,
        });

        console.log("Loan Response:", loanRes.data);

        const loan = loanRes.data?.[0];

        if (!loan) {
          console.log("Loan not found");
          return;
        }

        const loanProductId = loan.loanproduct_id;
        console.log("Loan Product ID:", loanProductId);

        const loanProductRes = await axios.post(
          url + "/loanproduct/getsingle",
          {
            token: Cookies.get("Token"),
            email: Cookies.get("Email"),
            loanproduct_id: loanProductId,
          }
        );

        console.log("Loan Product Response:", loanProductRes.data);
        setIsCoapplicant(loanProductRes.data[0]?.loanproduct_coapplicant);
        setIsCollateral(loanProductRes.data[0]?.loanproduct_collateral);
      } catch (error) {
        console.error("Error:", error.response?.data || error);
      }
    };

    if (loanid) {
      fetchLoanAndProduct();
    }
  }, [loanid]);

  const handleAddressUpload = async (e, cpv_type, response, loanID) => {
    console.log(cpv_type);
    openLoader();
    let address = e.target.files[0];
    if (!address) {
      closeLoader();
      return;
    }

    let docType = address.name.split(".").pop();
    if (docType !== "pdf") {
      closeLoader();
      toast.error("Please Upload PDF File Only");
      return;
    }

    if (loanID === "") {
      closeLoader();
      toast.error("Please select a loan ID");
      return;
    }
    let reader = new FileReader();
    reader.readAsDataURL(address);
    reader.onload = async (eve) => {
      const base64data = eve.target.result.split(",").pop();
      const req = {
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
        borrower_uniqueno: localStorage.getItem("uniqueID"),
        doc_name: cpv_type,
        loan_id: loanID,
        doc_type: "pdf",
        fileName: base64data,
        response: response,
      };

      const res = await axios.post(url + "/cpv/adddocument", req);
      if (!res.data.auth) {
        toast.error(res.data?.message);
        closeLoader();
        return;
      }
      toast.success(res.data?.message);
      fetchData();
      closeLoader();
      return;
    };
  };

  const tabs = [];

  if (permissions.view_loan) {
    tabs.push({
      label: "Loan",
      component: (
        <Loan
          cpvUpload={handleAddressUpload}
          openLoader={openLoader}
          closeLoader={closeLoader}
          permissions={permissions}
        />
      ),
    });
  }

  if (permissions.view_co_borrower && isCoapplicant) {
    tabs.push({
      label: "Co-Applicant",
      component: (
        <CoapplicantDetails
          openLoader={openLoader}
          closeLoader={closeLoader}
          permissions={permissions}
        />
      ),
    });
  }

  if (permissions.view_collateral && isCollateral) {
    tabs.push({
      label: "Collateral",
      component: (
        <CollateralDetails
          permissions={permissions}
          openLoader={openLoader}
          closeLoader={closeLoader}
        />
      ),
    });
  }

  if (permissions.view_loan) {
    tabs.push({
      label: "Analysis",
      component: (
        <Analysis
          cpvUpload={handleAddressUpload}
          openLoader={openLoader}
          closeLoader={closeLoader}
          permissions={permissions}
        />
      ),
    });

    tabs.push({
      label: "CAM",
      component: (
        <CAM
          openLoader={openLoader}
          closeLoader={closeLoader}
          permissions={permissions}
        />
      ),
    });
  }

  useEffect(() => {
    if (value >= tabs.length) {
      setValue(0);
    }
  }, [value, tabs.length]);

  return (
    <>
      {/* <ToastContainer /> */}
      <div className={styles.sectionTwo}>
        <div className={styles.sectionTwoContainer}>
          <Box
            sx={{
              width: "100%",
              minWidth: "50vw",
              "@media (max-width: 550px)": {
                width: "800px",
              },
              overflow: "hidden",
            }}
          >
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                scrollButtons="auto"
                variant="scrollable"
                aria-label="basic tabs example"
                sx={{
                  "& .css-heg063-MuiTabs-flexContainer": {
                    justifyContent: "center",
                    gap: "1vw",
                  },
                }}
              >
                {tabs.map((tab, index) => (
                  <Tab
                    key={index}
                    label={tab.label}
                    {...a11yProps(index)}
                    style={{
                      fontSize: "1rem",
                    }}
                  />
                ))}
              </Tabs>
            </Box>

            {tabs.map((tab, index) => (
              <TabPanel key={index} value={value} index={index}>
                {tab.component}
              </TabPanel>
            ))}
          </Box>
        </div>
      </div>
    </>
  );
};

export default SectionTwo;
